const componentsCommon=require("cb-components-common").default;
const request=componentsCommon.request;

export function getRiskAdjustmentChart() {
    return request({
        url: "/ui-api/v1/risk-adjustment-statistics",
        method: "get"
    });
}
export function getRiskAdjustmentTable() {
    return request({
        url: "/ui-api/v1/risk-adjustment-detail-statistics",
        method: "get"
    });
}
export function getRiskPortrait(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/risk-portrait?" + _params,
        method: "get"

    });
}

export function getLatestEvaluation(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/latest-evaluation",
        method: "get",
        params: _params
    });
}

export function downloadRiskDetailExcelFile(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/download-excel-file",
        method: "get",
        params: _params
    });
}

export function getMethodology(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/methodology",
        method: "get",
        params: _params
    });
}

export function getCompanyEvaluation(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/company-evaluation",
        method: "get",
        params: _params
    });
}

export function getCompanyEvaluationByName(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/company-evaluation-by-name?companyName=" + _params,
        method: "get"
    });
}

export function getSymbolHistoricalEvaluation(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/fund-historical-evaluation",
        method: "get",
        params: _params
    });
}

export function uploadFile(params, fileType) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/upload-section-file",
        method: "post",
        params: fileType,
        headers: {
            "Content-Type": "multipart/form-data",
            post: {
                "Content-Type": "multipart/form-data"
            }
        },
        data: _params
    });
}

export function addCustomSymbolList(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/custom-symbol-list",
        method: "post",
        data: _params
    });
}

export function removeCustomSymbolList(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/custom-symbol-list?symbol=" + params.symbol,
        method: "delete",
        data: _params
    });
}

export function getFundBySymbol(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/fund-by-symbol",
        method: "get",
        params: _params
    });
}

export function sendAllReportByFTP() {
    return request({
        url: "/ui-api/v1/send-all-report-by-fTP",
        method: "get"
    });
}

export function sendAllReportByEmail() {
    return request({
        url: "/ui-api/v1/send-all-report-by-email",
        method: "get"
    });
}

export function sendAllCompanyReportByFTP() {
    return request({
        url: "/ui-api/v1/send-all-company-report-by-fTP",
        method: "get"
    });
}



export function getCompanyList() {
    return request({
        url: "/ui-api/v1/company-list",
        method: "get"
    });

}
export function getFilter(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/filter",
        method: "get",
        params: _params
    });
}
export function getRiskDetail(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/risk-detail",
        method: "get",
        params: _params
    });
}
export function getRiskDetailBySymbol(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/risk-detail-by-symbol",
        method: "get",
        params: _params
    });
}

export function editSubscription(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/subscription",
        method: "put",
        data: _params
    });
}

export function getInfo() {
    return request({
        url: "/ui-api/v1/info",
        method: "get"
    });
}

export function editMyList(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/edit-my-list",
        method: "put",
        data: _params
    });
}

export function removeMyList(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/remove-my-list",
        method: "put",
        data: _params
    });
}

export function getDownloadFundReport(url) {
    return request({
        url: "/ui-api/v1/download-fund-report",
        method: "get",
        params: { url },
        responseType: "blob"
    });
}

export function getFundReports() {
    return request({
        url: "/ui-api/v1/fund-reports",
        method: "get",
    });
}

export function getFundReportsStatus() {
    return request({
        url: "/ui-api/v1/fund-reports-status",
        method: "get",
    });
}

export function deleteFundReportsStatus(params) {
    const _params = params || {};
    return request({
        url: "/ui-api/v1/fund-reports-key",
        method: "delete",
        params: _params
    });
}